import getIn from 'immutable-less/transmute/getIn';
import setIn from 'immutable-less/transmute/setIn';
export const createUpdateQueryCallback = fieldName => (prev, {
  fetchMoreResult
}) => {
  if (!fetchMoreResult) return prev;
  const resultsPath = [fieldName, 'results'];
  const prevResults = getIn(resultsPath, prev) || [];
  const newResults = getIn(resultsPath, fetchMoreResult) || [];
  return setIn(resultsPath, [...prevResults, ...newResults], fetchMoreResult);
};